export default "__VITE_ASSET__7e822abc__"